import { useRef } from "react";
import { useInView } from "framer-motion";

export default function useLazyVideo() {
	const containerRef = useRef(null);
	const videoRef = useRef(null);

	const isInView = useInView(containerRef, {
		margin: "200px",
		once: true,
	});

	if (isInView && videoRef.current) {
		videoRef.current.load();
	}

	return [containerRef, videoRef, isInView];
}
